import React, { useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import "../styles/global.scss"
import Footer from "./Footer/Footer"
import Header from "./Nav/Navbar"
// import ThemeContext from "../context/ThemeContext"
import { animated, useSpring } from "react-spring"
import CustomCursor from "./CustomCursor/CustomCursor"
import Form from "./Form/Form"
import Loader from "./Loader/Loader"
import { ToastContainer } from "react-toastify"
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader"
import gsap from "gsap"
import { useRef } from "react"
import { Script } from "gatsby"
deckDeckGoHighlightElement()

const Layout = ({ children, context }) => {
    // const theme = useContext(ThemeContext)
    // const darkMode = theme.state.darkMode
    const $pageWrapper = useRef(null)
    const [loading, setLoading] = useState(true)

    // const styles = useSpring({
    //     to: { opacity: 1 },
    //     from: { opacity: 0 },
    //     delay: 1500
    // })

    // useEffect(() => {
    //     const ctx = gsap.context(() => {
    //         const tl = gsap.timeline()
    //         gsap.set($pageWrapper.current, { opacity: 0 })

    //         tl.to($pageWrapper.current, {
    //             opacity: loading ? 0 : 1,
    //             duration: 10,
    //             delay: 1
    //         })
    //     }, $pageWrapper)

    //     return () => {
    //         ctx.revert()
    //     }
    // }, [loading])

    return (
        <div className={"app light"}>
            <Helmet
                htmlAttributes={{
                    lang: "en"
                }}
            >
                {/* GTM is now handled by gatsby-plugin-google-tagmanager */}
                <script
                    src="https://kit.fontawesome.com/87ffccf11b.js"
                    crossorigin="anonymous"
                ></script>
                <script
                    src="https://cdnjs.cloudflare.com/ajax/libs/snap.svg/0.5.1/snap.svg-min.js"
                    integrity="sha512-Gk+uNk8NWN235mIkS6B7/424TsDuPDaoAsUekJCKTWLKP6wlaPv+PBGfO7dbvZeibVPGW+mYidz0vL0XaWwz4w=="
                    crossorigin="anonymous"
                    referrerpolicy="no-referrer"
                ></script>
                <script
                    src="https://cdnjs.cloudflare.com/ajax/libs/snap.svg/0.5.1/snap.svg.js"
                    integrity="sha512-2B4yJ2DGhmYITzY51PcSK5pxQilqi1Cl3wgI8dq8phWjbVAw9SmcaTZp+QsSCdV/xKkxttyYolU0usNNG1ICbQ=="
                    crossorigin="anonymous"
                    referrerpolicy="no-referrer"
                ></script>
                <link rel="dns-prefetch" href="https://fonts.googleapis.com/" />
                <script>
                    {`!function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '1438904920232190');
                        fbq('track', 'PageView');`}
                </script>
                <script type="text/javascript">
                    {`_linkedin_partner_id = "4936812";
                    window._linkedin_data_partner_ids =
                    window._linkedin_data_partner_ids || [];
                    window._linkedin_data_partner_ids.push(_linkedin_partner_id);`}
                </script>
                <script type="text/javascript">
                    {`(function(l) {
                        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
                        window.lintrk.q=[]}
                        var s = document.getElementsByTagName("script")[0];
                        var b = document.createElement("script");
                        b.type = "text/javascript";b.async = true;
                        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
                        s.parentNode.insertBefore(b, s);})(window.lintrk);`}
                </script>
                <noscript>
                    {`<img
                        height="1"
                        width="1"
                        style="display:none"
                        src="https://www.facebook.com/tr?id=1438904920232190&ev=PageView&noscript=1"
                    />`}
                </noscript>
                <noscript>
                    {`<img
                        height="1"
                        width="1"
                        style="display:none;"
                        alt=""
                        src="https://px.ads.linkedin.com/collect/?pid=4936812&fmt=gif"
                    />`}
                </noscript>
                <link
                    rel="alternate"
                    href="https://saigon.digital/"
                    hreflang="en"
                />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "http://schema.org",
                        "@type": "LocalBusiness",
                        name: "Saigon Digital",
                        image: "https://saigon.digital/static/sd-logo-27b3834b36b8114f6dbc549225432fa1.svg",
                        telephone: "+84 332 364 293",
                        email: "",
                        address: {
                            "@type": "PostalAddress",
                            streetAddress: "19 To Huu, Thu Thiem Ward",
                            addressLocality: "Thu Duc City",
                            addressRegion: "Ho Chi Minh",
                            addressCountry: "Vietnam"
                        },
                        openingHoursSpecification: [
                            {
                                "@type": "OpeningHoursSpecification",
                                dayOfWeek: [
                                    "Monday",
                                    "Tuesday",
                                    "Wednesday",
                                    "Thursday",
                                    "Friday"
                                ],
                                opens: "09:00",
                                closes: "18:00"
                            }
                        ],
                        aggregateRating: {
                            "@type": "AggregateRating",
                            ratingValue: "4.9",
                            bestRating: "5",
                            ratingCount: "32"
                        },
                        url: "https://saigon.digital/"
                    })}
                </script>
            </Helmet>

            <div
                ref={$pageWrapper}
                className="transition duration-300"
                // style={{ opacity: loading ? 0 : 1 }}
            >
                <Header />
                <main className="overflow-x-clip pt-[75px] lg:pt-[100px]">
                    {children}
                </main>
                <Form context={context} />
                <Footer />
                <span className="hidden md:inline">
                    <CustomCursor />
                </span>
            </div>
            {/* <Loader setLoading={setLoading} /> */}
            <ToastContainer />
        </div>
    )
}
export default Layout
